import {v4 as uuidv4} from "uuid";
import {faker} from "@faker-js/faker";
//import defaultValues from "../scenarios/default";
import defaultValuesOld from "../scenarios/edu-scenarios";
import { getStorage, setStorage } from "../helpers/storage";
import { isArrayWithLength } from "../../utils/array-methods";

const defaultAccountNumber = "855075416228";

const accountState = ["CONNECTED"];
const regionList = [
  "us-east-1",
  "us-east-2",
  "eu-west-1",
  "eu-west-2",
  "us-west-1",
  "us-west-2",
  "ap-south-1",
  "ap-northeast-2",
  "ap-southeast-1",
  "ap-southeast-2",
  "ap-northeast-1",
  "ca-central-1",
  "eu-central-1",
  "eu-west-3",
  "sa-east-1",
];

var accounts1 = defaultValuesOld().accounts1;
var accounts2 = defaultValuesOld().accounts2;
var accounts3 = defaultValuesOld().accounts3;
var accounts4 = defaultValuesOld().accounts4;
var accounts5 = defaultValuesOld().accounts5;
var standbyAccounts = defaultValuesOld().standbyAccounts;
// var accounts6 = defaultValuesOld().accounts6;
// var accounts7 = defaultValuesOld().accounts7;

export const addData = (account) => {
  let randomRegionList = [];
  const regionCount = account.RegionCount
    ? account.RegionCount
    : faker.number.int({ min: 5, max: 10 });
  for (var i = 0; i < regionCount; ) {
    let randomRegion = faker.helpers.arrayElement(regionList);
    if (!randomRegionList.includes(randomRegion)) {
      randomRegionList.push(randomRegion);
      i++;
    }
  }
  const _getRegions = (regions) =>
    regions.map((reg) => ({
      RegionCode: reg,
      DiscoveryStatus: "COMPLETED",
      Error: null,
      Status: "CONNECTED",
    }));

  return {
    AdminPrivilege: true,
    AdminUpgradeRequired: false,
    AccountNumber: account.AccountNumber
      ? account.AccountNumber
      : defaultAccountNumber,
    AccountName: account.AccountName,
    DiscoveryStatus: "COMPLETE",
    AccountType: account.AccountType ? account.AccountType : "STANDALONE",
    AccountStatus: faker.helpers.arrayElement(accountState),
    IsDeleted: false,
    IsDisabled: false,
    Departments: account.Departments,
    RegionDiscovered: randomRegionList,
    CustomerAccountId: uuidv4(),
    ResourceId: uuidv4(),
    RegionSummary: {
      Summary: "OK",
      RegionsConfigured: randomRegionList.length,
      Regions: _getRegions(randomRegionList),
    },
    DesiredAccountStateInfo: {
      Status: faker.helpers.arrayElement(["NOT AVAILABLE"]),
      LastRun: faker.date.past(),
    },
    ParentAccountNumber: account.ParentAccountNumber
      ? account.ParentAccountNumber
      : null,
  };
};

export const getAllAccounts = () => {
  const newAccounts = [];
  if (isArrayWithLength(standbyAccounts)) {
    standbyAccounts.forEach((acc) => {
      newAccounts.push(addData(acc));
    });
  }
  if (isArrayWithLength(accounts1)) {
    accounts1.forEach((acc) => {
      newAccounts.push(addData(acc));
    });
  }
  if (isArrayWithLength(accounts2)) {
    accounts2.forEach((acc) => {
      newAccounts.push(addData(acc));
    });
  }
  if (isArrayWithLength(accounts3)) {
    accounts3.forEach((acc) => {
      newAccounts.push(addData(acc));
    });
  }
  if (isArrayWithLength(accounts4)) {
    accounts4.forEach((acc) => {
      newAccounts.push(addData(acc));
    });
  }
  if (isArrayWithLength(accounts5)) {
    accounts5.forEach((acc) => {
      newAccounts.push(addData(acc));
    });
  }
  return response(newAccounts);
};

const response = (data) => {
  return data;
};

export const accountResponseData = () => {
  const data = {
    ExternalId: "08438e5e-9a33-4067-8fee-40b75dd96154",
    MontyCloudTagId: "f8c449da-2755-43a9-b751-30aadfe131bd",
    MontyCloudInventoryId: "da9ecd94-9ecb-4b13-8373-bd5a94696460",
    CustomerAccountId: "f8c449da-2755-43a9-b751",
    OnboardingURL:
      "https://mcdev1customeronboarding.s3.amazonaws.com/MontyCloud-Onboarding-Role.yaml",
  };
  return response(data);
};

export const accountStatusData = () => {
  const data = {
    Status: "CONNECTED",
    AccountNumber: defaultAccountNumber,
  };
  return data;
};

export const accountDetails = (account) => {
  return {
    ...account,
    Regions: account.RegionDiscovered.map((r) => {
      return {
        DiscoveryStatus: "COMPLETED",
        Error: null,
        RegionCode: r,
        Status: "CONNECTED",
        DesiredRegionStateInfo: {
          Status: faker.helpers.arrayElement(["NOT AVAILABLE"]),
          LastRun: faker.date.past(),
        },
      };
    }),
  };
};

export const addAccountData = async (account) => {
  let departmentId = await getStorage("new_account_departmentId");
  return {
    AccountNumber: defaultAccountNumber,
    AccountName: account.AccountName,
    DiscoveryStatus: "COMPLETE",
    AccountStatus: "CONNECTED",
    IsDeleted: false,
    IsDisabled: false,
    DepartmentId: departmentId,
    Departments: [departmentId],
    RegionDiscovered: [],
    CustomerAccountId: "f8c449da-2755-43a9-b751",
    RegionSummary: {
      Summary: "OK",
      RegionsConfigured: 1,
      Regions: [
        {
          RegionCode: regionList[0],
          DiscoveryStatus: "COMPLETED",
          Error: null,
          Status: "CONNECTED",
        },
      ],
    },
    DesiredAccountStateInfo: {
      Status: faker.helpers.arrayElement(["NOT AVAILABLE"]),
      LastRun: faker.date.past(),
    },
    IsFirstRunView: account.IsFirstRunView,
  };
};

export const addAccountRegions = async (data) => {
  let accountList = await getStorage("ACCOUNTS");
  var index = accountList
    .map((e) => e.AccountNumber)
    .indexOf(data.AccountNumber);
  let account = accountList[index];
  if (account) {
    account.RegionDiscovered = data.Regions;
    account.RegionSummary.RegionsConfigured = data.Regions.length;
  }
  accountList[index] = account;
  await setStorage("ACCOUNTS", accountList);
};

export const setDASStatus = async (accountNumber) => {
  const accounts = await getStorage("ACCOUNTS");
  const updatedAccount =
    accounts &&
    accounts.map((a) => {
      if (a.AccountNumber === accountNumber) {
        return {
          ...a,
          DesiredAccountStateInfo: {
            Status: "SUCCESS",
            LastRun: new Date(),
          },
        };
      }
      return a;
    });
  await setStorage("ACCOUNTS", updatedAccount);
};
